import React, { PureComponent } from 'react';
import { func, string } from 'prop-types';
import { Button, Responsive } from 'common/components';
import './index.css';

/**
 *
 *
 * @export
 * @class ChartEmptyState
 * @extends {PureComponent}
 */
export default class ChartEmptyState extends PureComponent {
  static displayName = 'ChartEmptyState';

  static propTypes = {
    navigateTo: func,
    chartTitle: string,
    title: string,
    subTitle: string,
    buttonText: string,
  };

  static defaultProps = {
    chartTitle: '',
    title: '',
    subTitle: '',
    buttonText: 'button',
  };

  render() {
    const { navigateTo, title, subTitle, buttonText, chartTitle } = this.props;

    return (
      <div data-testid="ChartEmptyState" className="chart-empty-state">
        <h2 className="text--header chart-empty-state__title">{chartTitle}</h2>
        <div className="chart-empty-state__content">
          <p className="chart-empty-state__text">{title}</p>
          <p className="chart-empty-state__subtext">{subTitle}</p>
          {navigateTo ? (
            <Button
              className="btn btn--secondary btn--add"
              onClick={navigateTo}
            >
              <Responsive.Desktop>{buttonText}</Responsive.Desktop>
            </Button>
          ) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ChartEmptyState/index.js